module.exports = __webpack_public_path__ + "static/media/image_42.ec286969.png";